import { render, staticRenderFns } from "./ProjectViewAttestation.vue?vue&type=template&id=710d9eff&"
import script from "./ProjectViewAttestation.vue?vue&type=script&lang=js&"
export * from "./ProjectViewAttestation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports